function showStickyFooter(footer) {
    const footerYpos = footer.getBoundingClientRect().top + window.scrollY;

    if (footerYpos > 700) {
        footer.classList.remove('stickyFooter--hidden');
    } else {
        footer.classList.add('stickyFooter--hidden');
    }
}

function init() {
    const footer = document.querySelector('.js_stickyFooter');

    if (footer) {
        showStickyFooter(footer);

        document.addEventListener('scroll', e => showStickyFooter(footer));
    }
}

$(document).ready(init);
